module.exports = __webpack_public_path__ + "static/SingleProductOrder-4e3a38cd63304180e665a0e71674ef33.png";